import React from 'react';

function Fin({ dir, level }) {
  return (
    <div className="questionContent questionEnding questionFin">
      <div className="questionTxt">
        <div className="questionTxtInner">
          <p className="txtFin">おしまい</p>
          <p className="txtLg">{level < 2 ? '次のレベルにチャレンジしてみるのじゃ！' : 'おめでとう！キミもりっぱな植物はかせじゃ！'}</p>
        </div>
        <button
          onTouchStart={() => {}}
          className="questionBtn questionTopBtn btn-10"
          onClick={() => {
            location.href = 'https://www.tanabotanical.com/virtual/';
          }}
        >
          <img src={dir + 'assets/img/btn-top.png'} alt="TOPにもどる" />
        </button>
      </div>
    </div>
  );
}

export default Fin;
